import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { ListItem, ListItemIcon, ListItemText  } from 'material-ui/List';
import DeleteIcon from 'material-ui-icons/Delete';

import { deleteLayers } from '../../../../actions'
import {
  getExtraCoreCount,
  getNeighborPrepreg,
  getMirrorLayer
} from '../../../../reducers';
import DeleteCoreDialog from './DeleteCoreDialog';
import { Core, Material, Prepreg } from '../../../../models';

export class DeleteCoreMenuItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogOpen: false
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
  }

  handleClick() {
    this.openDialog();
  }

  openDialog() {
    this.setState({
      dialogOpen: true
    });
  }

  closeDialog() {
    this.setState({
      dialogOpen: false
    });
  }

  handleCancel() {
    const { onClick } = this.props;
    this.closeDialog();
    onClick();
  }

  handleConfirm({ deleteMirror }) {
    const {
      onClick,
      material,
      neighborPrepreg,
      mirrorCore,
      mirrorPrepreg,
      // from dispatch to prosp;
      deleteLayers 
    } = this.props;

    const indexiToDelete = [
      material.index - 1,   // Copper on top of core
      material.index,       // core
      material.index + 1,   // core
      neighborPrepreg.index // prepreg
    ];

    if (deleteMirror && mirrorCore && mirrorPrepreg) {
      indexiToDelete.push(...[
        mirrorCore.index -1,
        mirrorCore.index,
        mirrorCore.index + 1,
        mirrorPrepreg.index
      ]);
    }
    deleteLayers(indexiToDelete);
    this.closeDialog();
    onClick();
  }

  render() {
    const { material, deletePrepregAbove, mirrorCore, unit } = this.props;
    // props from redux;
    const { extraCoreCount, neighborPrepreg } = this.props;
    const { dialogOpen } = this.state;
    const displayName = material ? material.toString(unit): 'this Core';
    const belowOrAvobe = deletePrepregAbove ? 'above' : 'below'
    const prepregName = neighborPrepreg ? neighborPrepreg.toString(unit): '';
    const text =
      `Delete ${displayName} and Prepreg ${belowOrAvobe} ${prepregName}`;
    const disabled = material === undefined ||
      extraCoreCount <= 0 ||
      neighborPrepreg === undefined;
    const showDeleteMirrorOption = extraCoreCount >= 2 && mirrorCore.index !== material.index;

    return (
      <div>
        <ListItem button onClick={this.handleClick} disabled={disabled}>
          <ListItemIcon>
            <DeleteIcon />
          </ListItemIcon>
          <ListItemText primary={text} />
        </ListItem>
        <DeleteCoreDialog 
          displayName={displayName}
          belowOrAvobe={belowOrAvobe}
          open={dialogOpen}
          mirrorCore={showDeleteMirrorOption ? mirrorCore : undefined}
          handleClose={this.handleCancel}
          handleConfirm={this.handleConfirm}
        />
      </div>
    );
  }
}

 function mapStateToProps(state, ownProps) {
   const { material, deletePrepregAbove: above } = ownProps;
   const extraCoreCount = getExtraCoreCount(state);
   const neighborPrepreg = getNeighborPrepreg(state, material.index, above);
   const mirrorCore = getMirrorLayer(state, material.index);
   const mirrorPrepreg = neighborPrepreg 
    ? getMirrorLayer(state, neighborPrepreg.index)
    : undefined;

   return {
     extraCoreCount,
     neighborPrepreg,
     mirrorCore,
     mirrorPrepreg
   };
 }

const mapDispatchToProps = {
   deleteLayers
};

DeleteCoreMenuItem.defaultProps = {
  neighborPrepreg: undefined,
  mirrorCore: undefined,
  mirrorPrepreg: undefined
}

DeleteCoreMenuItem.propTypes = {
  deleteLayers:       PropTypes.func.isRequired,
  deletePrepregAbove: PropTypes.bool.isRequired,
  material:           PropTypes.instanceOf(Material).isRequired,
  onClick:            PropTypes.func.isRequired,
  extraCoreCount:     PropTypes.number.isRequired,
  neighborPrepreg:    PropTypes.instanceOf(Prepreg), 
  mirrorCore:         PropTypes.instanceOf(Core),
  mirrorPrepreg:      PropTypes.instanceOf(Prepreg),
  unit:               PropTypes.string.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteCoreMenuItem);


// WEBPACK FOOTER //
// ./src/components/StackupDesign/Viewer/MenuDrawer/DeleteCoreMenuItem.js